import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import KBreadcrumb from '../index.js';

var KBasketBreadcrumb = function KBasketBreadcrumb(_a) {
    var basketTotalCount = _a.basketTotalCount, basketTitle = _a.basketTitle, onMyBasketsClick = _a.onMyBasketsClick, KIcon = _a.KIcon, sx = _a.sx, rest = __rest(_a, ["basketTotalCount", "basketTitle", "onMyBasketsClick", "KIcon", "sx"]);
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Box, { sx: __assign(__assign({ display: "flex" }, sx), { "& .KBreadcrumb-itemTypo": {
                fontSize: { xs: "0.7rem", sm: "0.8rem" }
            }, "& .MuiBreadcrumbs-ol": {
                fontSize: { xs: "0.7rem", sm: "0.8rem" }
            } }) },
        React__default.createElement(KBreadcrumb, __assign({ KIcon: KIcon, items: [
                {
                    id: "baskets",
                    label: t("components.KBasketBreadcrumb.mybasket", {
                        basketTotalCount: basketTotalCount
                    }),
                    onClick: onMyBasketsClick
                },
                { id: "currentBasket", label: basketTitle },
            ], sx: __assign({}, sx) }, rest))));
};

export { KBasketBreadcrumb as default };
//# sourceMappingURL=index.js.map
